// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App-level styles (kept minimal – page-specific styles live in index.css or components) */
.App { min-height: 100vh; background: oklch(var(--page)); color: oklch(var(--foreground)); }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,2FAA2F;AAC3F,OAAO,iBAAiB,EAAE,8BAA8B,EAAE,+BAA+B,EAAE","sourcesContent":["/* App-level styles (kept minimal – page-specific styles live in index.css or components) */\n.App { min-height: 100vh; background: oklch(var(--page)); color: oklch(var(--foreground)); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
